
import hardware from "../image/hardware.jpeg";
import security from "../image/network.jpeg";
import software from "../image/software.jpeg";
import ai from "../image/ai.png";
import heroAll from "../image/hero_all.png";
import marketing from "../image/marketing.png";

 const slides = [
    {
      img: heroAll,
      title: "Transforming Businesses Through Smart Technology",
      desc: "From enterprise IT infrastructure and cybersecurity to AI automation, software development, cloud solutions, websites, mobile apps, and digital marketing—we deliver complete technology solutions that drive innovation, security, and business growth.",
    },
  
    {
      img: hardware,
      title: "Powering Businesses with Reliable IT Infrastructure",
      desc: "Build a stronger foundation with premium hardware, enterprise networking, cloud infrastructure, and scalable IT solutions engineered for maximum performance and reliability.",
    },
  
    {
      img: security,
      title: "Secure Today. Protect Tomorrow.",
      desc: "Stay ahead of threats with intelligent CCTV surveillance, biometric access control, cybersecurity, and integrated security solutions designed to keep your business safe 24/7.",
    },
  
    {
      img: software,
      title: "Custom Software That Accelerates Growth",
      desc: "We design and develop powerful websites, business software, ERP, CRM, eCommerce platforms, and mobile applications that streamline operations and deliver exceptional user experiences.",
    },
  
    {
      img: ai,
      title: "Smarter Business with AI & Automation",
      desc: "Unlock new levels of productivity through AI-powered automation, intelligent workflows, cloud technologies, and data-driven solutions that transform the way you work.",
    },
  
    {
      img: marketing,
      title: "Grow Faster with Digital Marketing Excellence",
      desc: "Boost your online presence with SEO, social media marketing, WhatsApp campaigns, email marketing, paid advertising, and branding strategies that generate quality leads and measurable business growth.",
    },
  ];


  export default slides;